import baseAPI from '@/api';
import { GameWinProbabilityInputDto } from '@/services/dto/games/game-win-probability-input.dto';
import { Decimal } from '@starsoft/common/services/Decimal';
import { QueryFunctionContext } from '@tanstack/react-query';
import { UseGameWinProbabilityQueryKey } from './props';

export async function fetchGameWinProbability({
  queryKey,
}: QueryFunctionContext<UseGameWinProbabilityQueryKey>): Promise<Decimal> {
  try {
    const { gameId, crashpoint }: GameWinProbabilityInputDto = queryKey[1];

    const response = await baseAPI.get<Decimal>('/games/win-probability', {
      params: {
        gameId,
        crashpoint,
      },
    });

    return response.data;
  } catch (error) {
    return undefined;
  }
}
